import type { SchemaDiffRow } from './proposal-diff'

export interface SchemaDiffGroup {
  target: string
  label: string
  kind: 'entity' | 'relationship' | 'pattern' | 'schema'
  operation: SchemaDiffRow['operation']
  rows: SchemaDiffRow[]
}

function groupIdentity(target: string): Pick<SchemaDiffGroup, 'target' | 'label' | 'kind'> {
  const [section, label] = target.split('.')
  if (section === 'entities' || section === 'relationships')
    return {
      target: `${section}.${label}`,
      label,
      kind: section === 'entities' ? 'entity' : 'relationship',
    }
  if (section === 'patterns')
    return { target, label: target.slice('patterns.'.length), kind: 'pattern' }
  return { target, label: target, kind: 'schema' }
}

/** An entity and its properties are one review decision, not eight unrelated
 * cards. Preserve every field-level delta inside its group. */
export function groupProposalDiff(rows: SchemaDiffRow[]): SchemaDiffGroup[] {
  const groups = new Map<string, SchemaDiffGroup>()
  for (const row of rows) {
    const identity = groupIdentity(row.target)
    const group = groups.get(identity.target)
    if (group) group.rows.push(row)
    else groups.set(identity.target, { ...identity, operation: row.operation, rows: [row] })
  }
  return [...groups.values()].map(group => ({
    ...group,
    operation:
      group.kind === 'entity' || group.kind === 'relationship'
        ? (group.rows.find(row => row.target === group.target)?.operation ?? 'change')
        : group.operation,
  }))
}
